import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  Menu,
  MenuItem,
  Avatar,
  Select,
  SelectChangeEvent,
  FormControl,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useMsal } from '@azure/msal-react';
import { useAppDispatch } from '../../storeHook';
import { resetAuthUser } from '../../services/features/authUserSlice';
import { deleteToken } from '../../services/tokenSlice';
import Advantalogo from '../../assets/images/Advantalogo.png';
import './index.scss';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { setSelectedCountry } from '../../services/features/countrySlice';

export const MVPAppHeader: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  //const isVerySmall = useMediaQuery('(max-width: 320px)');
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  const user = useSelector(
    (state: RootState) => state.authUser
  );

  const userName = user?.userName;
  const userDesignation = user?.role;
  const userCountry = user?.countryName;
  const isSuperAdmin = user?.role === 'SUPER_ADMIN';

  const selectedCountry = useSelector(
    (state: RootState) => state.country.selectedCountry
  );
  const reduxDispatch = useDispatch();

  const handleCountryChange = (
    event: SelectChangeEvent<string>
  ) => {
    reduxDispatch(setSelectedCountry(event.target.value));
  };

  const [anchorEl, setAnchorEl] =
    useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();

    instance.logoutRedirect({
      onRedirectNavigate: () => false,
    });

    localStorage.removeItem('authToken');
    sessionStorage.removeItem('pageReloaded');
    localStorage.removeItem('screen_url');
    dispatch(resetAuthUser());
    dispatch(deleteToken());
    window.location.reload();
  };

  return (
    <div>
      <AppBar className="main-app-bar-container">
        <Box
          className="main-container"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            padding: isMobile ? '8px 16px' : '8px 24px',
            marginTop: isMobile ? '8px' : '10px',
          }}>
          {/* Left side - Logo */}
          {!isMobile && (
            <Box
              sx={{ display: 'flex', alignItems: 'center' }}
              onClick={() =>
                navigate(`/mvp/charts#scatter-plot`)
              }>
              <img
                src={Advantalogo}
                alt="Advanta Logo"
                style={{
                  height: '35px',
                  objectFit: 'contain',
                }}
              />
            </Box>
          )}

          {/* Country Selector */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: isMobile ? 1 : 2,
            }}>
            <FormControl size="small">
              <Select
                value={selectedCountry}
                onChange={handleCountryChange}
                disabled={!isSuperAdmin}
                sx={{
                  minWidth: 120,
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  fontSize: 14,
                  '.MuiSelect-select': {
                    padding: '6px 12px',
                  },
                }}>
                {isSuperAdmin ? (
                  [
                    <MenuItem key="india" value="india">
                      India
                    </MenuItem>,
                    <MenuItem
                      key="thailand"
                      value="thailand">
                      Thailand
                    </MenuItem>,
                  ]
                ) : (
                  <MenuItem value={selectedCountry}>
                    {userCountry ||
                      selectedCountry
                        .charAt(0)
                        .toUpperCase() +
                        selectedCountry.slice(1)}
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            {/* Profile / Dropdown */}
            {!isMobile ? (
              // -------- Desktop: Show name + designation + arrow
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={handleMenuOpen}>
                <Box sx={{ textAlign: 'left', mr: 1 }}>
                  <Typography
                    fontSize={14}
                    fontWeight="bold"
                    display="block">
                    {userName}
                  </Typography>
                  <Typography
                    fontSize={12}
                    color="text.secondary"
                    display="block">
                    {userDesignation}
                  </Typography>
                </Box>
                <KeyboardArrowDownIcon
                  sx={{ color: 'black' }}
                />
              </Box>
            ) : (
              <IconButton onClick={handleMenuOpen}>
                <Avatar
                  sx={{
                    bgcolor: '#1976d2',
                    width: 25,
                    height: 25,
                    fontSize: 12,
                  }}>
                  {userName.charAt(0)}
                </Avatar>
              </IconButton>
            )}

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}>
              {isMobile && (
                <Box sx={{ px: 2, py: 1 }}>
                  <Typography
                    fontSize={14}
                    fontWeight="bold">
                    {userName}
                  </Typography>
                  <Typography
                    fontSize={12}
                    color="text.secondary">
                    {userDesignation}
                  </Typography>
                </Box>
              )}
              <MenuItem onClick={handleLogout}>
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </AppBar>
    </div>
  );
};

export default MVPAppHeader;
